import React from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import Module from '../../components/Module';
import ModuleContent from '../../components/ModuleContent';
import SubModule from '../../components/SubModule';
import SubModuleContent from '../../components/SubModuleContent';
import SubModuleHeader from '../../components/SubModuleHeader';
import AdjustmentListTab from '../../components/AdjustmentListTab';
import AdvanceGroupListTab from '../../components/AdvanceGroupListTab';

const ContractAdjustments = () => {
  const { contractAddress } = useParams();
  const contract = useSelector(state => get(state, `entities.contracts.${contractAddress}`, null));

  return (
    contract && (
      <>
        <Module>
          <ModuleContent>
            <SubModule>
              <SubModuleHeader id="adjustments" noBorder noSpacing>
                Adjustments
              </SubModuleHeader>
              <SubModuleContent>
                <AdjustmentListTab
                  contractId={contract.contractId}
                  hiddenColumns={['contractId', 'createdBy']}
                  perLineItem
                />
              </SubModuleContent>
            </SubModule>
          </ModuleContent>
        </Module>

        <Module>
          <ModuleContent>
            <SubModule>
              <SubModuleHeader id="advanceGroups" noBorder noSpacing>
                Advance Groups
              </SubModuleHeader>
              <SubModuleContent>
                <AdvanceGroupListTab
                  contractId={contract.contractId}
                  contractCurrency={contract.contractCurrency}
                  hiddenColumns={['contractId', 'contractName', 'partnerName']}
                />
              </SubModuleContent>
            </SubModule>
          </ModuleContent>
        </Module>
      </>
    )
  );
};

export default ContractAdjustments;
